import React from 'react';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import { makeStyles } from '@material-ui/core/styles';
import { formatNumber } from './utils/formatDashboard';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    height: '100%',
  },
  statRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': { borderBottom: 'none' },
  },
}));

const AgentStatsSection = ({ agents, loading }) => {
  const classes = useStyles();
  const history = useHistory();

  const rows = agents
    ? [
        { label: 'Total Agents', value: formatNumber(agents.totalAgents) },
        { label: 'Active', value: formatNumber(agents.activeAgents) },
        { label: 'Inactive', value: formatNumber(agents.inactiveAgents) },
        { label: 'Pending Requests', value: formatNumber(agents.pendingAgentRequests) },
        { label: 'Pending Personal Accounts', value: formatNumber(agents.pendingPersonalAccountRequests) },
      ]
    : [];

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardHeader title="Agent Statistics" titleProps={{ variant: 'h5' }}>
        <Button color="primary" onClick={() => history.push('/agent')}>
          <Box component="span" mr={1}>
            Go to agent list
          </Box>
          <NavigateNextIcon />
        </Button>
      </CmtCardHeader>
      <CmtCardContent>
        {loading ? (
          <Skeleton variant="text" height={40} />
        ) : (
          rows.map(({ label, value }) => (
            <div key={label} className={classes.statRow}>
              <Typography variant="body2" color="textSecondary">
                {label}
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {value}
              </Typography>
            </div>
          ))
        )}
      </CmtCardContent>
    </CmtCard>
  );
};

export default AgentStatsSection;
